const gridContainer = document.querySelector('.grid-container');

context.products.forEach(product => {
  let gridItem = `<div class="grid-item" data-keywords="${product.vendor} ${product.name}">
                        <div class="product-vendor">${product.vendor}</div>
                        <div class="product-name">${product.name}</div>
                        <div class="product-footer">Eau de parfum</div>
                        <div class="btn-select">Select</div>
                    </div>`;
  gridContainer.insertAdjacentHTML('beforeend', gridItem);
});

const btnSelect = document.querySelectorAll('.btn-select');

btnSelect.forEach(btn => btn.addEventListener('click', selectScent));

function selectScent(event){
  const clickedButton = event.target;
  const productName = clickedButton.parentElement.querySelector('.product-name').textContent;
  const parentContainer = event.target.closest('.grid-container');
  let selectedProducts = parentContainer.dataset.selected;

  if (Number(selectedProducts) == 2 && !clickedButton.classList.contains('remove')) return;

  if( clickedButton.classList.contains('remove') ) {
    clickedButton.classList.remove('remove');
    clickedButton.textContent = 'Select';
    parentContainer.dataset.selected = Number(selectedProducts) - 1;
    parentContainer.classList.remove('max-limit');

    const index = context.selectedProducts.indexOf(productName);
    context.selectedProducts.splice(index, 1);

    document.querySelectorAll('.btn-select:not(.remove)').forEach(btn => {
      btn.textContent = 'select';
    })

    if( Number(parentContainer.dataset.selected) == 0) {
      parentContainer.closest('.quiz-view').querySelector('.button--blue').style.display = 'none';
    }

    return;
  }

  clickedButton.textContent = 'remove';
  clickedButton.classList.add('remove');
  parentContainer.dataset.selected = Number(selectedProducts) + 1;
  parentContainer.closest('.quiz-view').querySelector('.button--blue').style.display = 'inline-flex';
  context.selectedProducts.push(productName);

  if( Number(parentContainer.dataset.selected) == 2) {
    parentContainer.classList.add('max-limit');
    document.querySelectorAll('.btn-select:not(.remove)').forEach(btn => {
      btn.textContent = 'max product selected';
    })
  }
}


const smellImages = document.querySelectorAll('.smell-img-wrapper img');
smellImages.forEach( el => el.addEventListener('click', selectImageScent));

function selectImageScent() {
  const scentContainer = this.closest('.smell-container');
  const prop = scentContainer.classList.contains('js-liked-smells') ? 1 : 0;
  const selectedScents = Number(scentContainer.dataset.selected);
  const scent = this.closest('.smell-img-wrapper').dataset.scent;

  if( selectedScents == 3 && !this.classList.contains('selected') ) return

  if(this.classList.contains('selected')) {
    this.classList.remove('selected');
    scentContainer.dataset.selected = selectedScents - 1;

    delete context.selectedSmells[scent];

    if( selectedScents == 1 && !scentContainer.classList.contains('js-disliked-smells')) {
      scentContainer.closest('.quiz-view').querySelector('.button--blue').style.display = 'none';
    }

    return
  }

  this.classList.add('selected');
  document.querySelector('.step-03a').classList.add('disabled');
  scentContainer.dataset.selected = selectedScents + 1;
  context.selectedSmells[scent] = prop; // can be 1 or 0 meaning liked or disliked smell
  scentContainer.closest('.quiz-view').querySelector('.button--blue').style.display = 'inline-flex';
  console.log(context.selectedSmells);
  let scentsToDisable = [];

  // Step 1: Attach click event listeners to each .smell-img-wrapper within .step-02a
  document.querySelectorAll('.step-02a .smell-img-wrapper').forEach(element => {
    element.addEventListener('click', function() {
      let scent = this.getAttribute('data-scent');
      // console.log(`Clicked scent in .step-02a: ${scent}`);

      if (scent) {
        if (!scentsToDisable.includes(scent)) {
          scentsToDisable.push(scent);
          // console.log(`Added ${scent} to scentsToDisable array`);
        } else {
          // Remove the scent from the array if it's already there (toggle off)
          const index = scentsToDisable.indexOf(scent);
          if (index > -1) {
            scentsToDisable.splice(index, 1);
            // console.log(`Removed ${scent} from scentsToDisable array`);
          }
        }
      }
    });
  });

  // Step 2: Attach click event listener to the next button, which is a sibling of .js-liked-smells
  let likedSmellsContainer = document.querySelector('.step-02a .js-liked-smells');
  if (likedSmellsContainer && likedSmellsContainer.nextElementSibling && likedSmellsContainer.nextElementSibling.classList.contains('js-next-step-btn')) {
    let nextButton = likedSmellsContainer.nextElementSibling;
    // console.log('Next button found as a sibling of .js-liked-smells in .step-02a');
    nextButton.addEventListener('click', function() {
      // console.log('Next button in .step-02a clicked');
      scentsToDisable.forEach(scent => {
        document.querySelectorAll(`.step-03a .smell-img-wrapper[data-scent="${scent}"]`).forEach(element => {
          window.scrollTo({top: 0, behavior: 'smooth'});
          element.classList.add('disabled');
          // console.log(`Disabled .smell-img-wrapper with scent: ${scent} in .step-03a`);
        });
      });
    });
  } else {
    // console.log('Next button not found as a sibling of .js-liked-smells in .step-02a');
  }


  // Step 3: Attach click event listener to the prev button in .step-03a
  let prevButton = document.querySelector('.step-03a .prev-btn');
  if (prevButton) {
    // console.log('Previous button found in .step-03a');
    prevButton.addEventListener('click', function() {
      // console.log('Previous button in .step-03a clicked');
      // scentsToDisable = [];
      // console.log('scents left are' + scentsToDisable);
      document.querySelectorAll('.step-03a .smell-img-wrapper').forEach(element => {
        if (element.classList.contains('disabled')) {
          element.classList.remove('disabled');
          // console.log(`Removed 'disabled' class from .smell-img-wrapper in .step-03a`);
        }
      });
    });
  } else {
    // console.log('Previous button not found in .step-03a');
  }

}

function submitDataToKlaviyo(email, quizStep, quizGeneratedResults) {

  const properties = quizStep === 'Quiz step A' ? {
    $source: quizStep,
    quizAnswerBoughtBefore: context.quizAnswerBoughtBefore,
    quizGeneratedResultsStepA: quizGeneratedResults.join(',')
  } : {
    $source: quizStep,
    quizAnswerBoughtBefore: context.quizAnswerBoughtBefore,
    quizGeneratedResultsStepB: quizGeneratedResults.join(',')
  }
  const subscribeOptions = {
    method: 'POST',
    headers: {
      revision: '2025-01-15',
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: quizStep,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
              },
              properties: {
                ...properties,
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: 'TXpCBy',
            }
          }
        },
      },
    }),
  };

  fetch('https://a.klaviyo.com/client/subscriptions/?company_id=WFqL6s', subscribeOptions)
    .then(response => response)
    .then(response => console.log('Email submitted from step ' + quizStep))
    .catch(err => console.error(err));

  const step = quizStep === 'Quiz step A' ? 'A' : 'B';
  const metricOptions = {
    method: 'POST',
    headers: {
      accept: 'application/json',
      revision: '2025-01-15',
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      data: {
        type: 'event',
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email
              }
            }
          },
          metric: {
            data: {
              type: 'metric',
              attributes: {
                name: 'Quiz completed'
              },
            }
          },
          properties: {
            step,
            quizAnswerBoughtBefore: context.quizAnswerBoughtBefore,
            generatedProductIds: quizGeneratedResults.join(',')
          },
        },
      },
    }),
  };

  fetch('https://a.klaviyo.com/client/events/?company_id=WFqL6s', metricOptions)
    .then(response => response)
    .catch(err => console.error(err));
}

function validateEmail(mail) {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) return true;
  return false;
}

function showQuizResults() {
  const inputEmail = document.querySelector('#quiz-useremail');
  const emailValue = inputEmail.value;

  if(!validateEmail(emailValue)) return;

  const temp = document.querySelector('#products-temp');
  const resultsContainer = document.querySelector('.quiz-results-container');
  const selectedAnswers = context.selectedProducts;
  let arr = [];
  context.products.forEach(prod => selectedAnswers.includes(prod.name) && arr.push(prod.similarProductIds));
  console.log({"foundProducts" : arr.flat()});

  const foundProducts = arr.flat();


  // Branch A
  if(foundProducts.length > 0) {
    resultsContainer.innerHTML = '';
    const quizGeneratedResults = []
    foundProducts.forEach(prod => {
      const item = temp.content.querySelector(`#${prod}`);
      if (!(item instanceof Node)) return;
      const product = item.cloneNode(true);
      const productId = item.getAttribute('data-product-id');
      quizGeneratedResults.push(productId);
      resultsContainer.appendChild(product);
    });
    submitDataToKlaviyo(emailValue, context.step, quizGeneratedResults);
    if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
      yotpoWidgetsContainer.initWidgets();
    }
  } else if(Object.keys(context.selectedSmells).length > 0) {
  // Branch B
    let matchingProducts = []; //array of products name
    const quizGeneratedResults = []
    fetch("https://quiz.trydossier.co/products/aus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(context.selectedSmells)
    }).then(res => res.json())
      .then(data => {
        data.products.forEach(prod => matchingProducts.push( `${prod.nameFamily.toLowerCase()}-${prod.nameNote.toLowerCase()}`));
        console.log(matchingProducts);
        resultsContainer.innerHTML = '';
        matchingProducts.forEach(scent => {
          const item = temp.content.querySelector( `[id^="${scent}"]`);
          if(!item) return;
          const product = document.importNode(item, true);
          resultsContainer.appendChild(product);
          const productId = item.getAttribute('data-product-id');
          quizGeneratedResults.push(productId);
        });
        return data;
      })
      .then(() => {
        submitDataToKlaviyo(emailValue, context.step, quizGeneratedResults);
        if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets === 'function') {
          yotpoWidgetsContainer.initWidgets();
        }
      });
  } else {
    resultsContainer.textContent = "Sorry, no matches found.";
  }
}

function quizAnswer(){
  const answer = this.dataset.answer;
  const slide = this.closest('.quiz-view');

  if(slide.classList.contains('step-00')) {
    context.quizAnswerBoughtBefore = answer;
  } else {
    context.step = answer;
  }
}

function searchProduct() {
  const searchValue = this.value;
  const regExp = new RegExp(searchValue, "i");
  const items = document.querySelectorAll('.grid-item');

  items.forEach(item => {
    const itemKeywords = item.dataset.keywords;
    itemKeywords.search(regExp) !== -1 ? item.style.display = "block" : item.style.display = "none";
  })

}

const inputProductSearch = document.querySelector('.js-input-search');
const showResultsButton = document.querySelector('.js-show-results');
const klaviyoButtons = document.querySelectorAll('.js-klaviyo-answer');
inputProductSearch.addEventListener('keyup', searchProduct);
showResultsButton.addEventListener('click', showQuizResults);
klaviyoButtons.forEach(btn => btn.addEventListener('click', quizAnswer));